__turbopack_context__.v({
  "badge": "TechBadge-module-scss-module__rDFvxa__badge",
  "label": "TechBadge-module-scss-module__rDFvxa__label",
});
